export const aws = {
    "bucketName": "",
    "accessKey": "",
    "secretAccessKey": "",
    "directoryName": "resume",
    "region": "1"
}